/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
/// <reference path="../../components/baseclasses/dataMaintenanceContextBase.ts" />

module Meevo.Plugins.TextelBlast {

    "use strict";

    export interface ISectionParamsTextelBlast {
        sectionId: number;
        displayNameContentKey: string;
        template: string;
        isPrimarySection: boolean;
        handlesOwnCrud: boolean;
        baseEndpoint: string;
        sectionEndpoint: string;
        loggingService: Meevo.Components.Logging.ILoggingService;
        dataService: Meevo.Components.CommonClasses.ICommonDataService;
        context: TextelBlastContext;
        identityService: Meevo.Components.Common.IIdentityService;
        noun: Meevo.Model.NounEnum;
        appSettings: Meevo.Components.Common.IAppSettings;
        sectionSecurityKey?: string;
    }

    export class TextelBlastContext extends Meevo.Components.CommonClasses.CommonContextBase {

        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        protected securityParts = Meevo.Components.Common.SecurityParts;

        window: ng.IWindowService;

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            dataService:Meevo.Components.CommonClasses.ICommonDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected $translate: angular.translate.ITranslateService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            $window: angular.IWindowService
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);
            this.baseEndpoint = '';
            this.sectionTemplatePath = 'app/plugins/textelBlast/sectionViews/';
            this.window = $window;

            this.initializeSections();

            this.selectSection(this.sections[0]);
        }


        initializeSections(): void {
            let baseSectionProps: ISectionParamsTextelBlast = {
                sectionId: 0,
                displayNameContentKey: 'SECTION_MAIN',
                template: 'main.html',
                isPrimarySection: true,
                handlesOwnCrud: true,
                baseEndpoint: this.baseEndpoint,
                sectionEndpoint: 'BasicMarketing/GetAccountId',
                loggingService: this.loggingService,
                dataService: this.dataService,
                context: this,
                identityService: this.identityService,
                noun: Meevo.Model.NounEnum.TextelMarketingMain,
                appSettings: this.appSettings,
                sectionSecurityKey: this.securityKeys.INTEGRATION_TEXTELMARKETING + Meevo.Components.Common.SecurityParts.KEY_PART_READ
            };

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_TEXTELMARKETING +
                Meevo.Components.Common.SecurityParts.KEY_PART_READ)) this.sections.push(new MainSection(baseSectionProps, this.window));
        }

        initializeHeader(model: any): void {
        }
    }
}
